import './styles/fastig.scss'

// Initialize Sentry before importing App
import './sentry'

import App from '@/App'
import SentryErrorBoundary from './components/SentryErrorBoundary'
import { HashRouter } from 'react-router-dom'
import React from 'react'
import ReactDOM from 'react-dom'
import reportWebVitals from './reportWebVitals'

const integrateRedirects = ['/integrate/fortnox', '/integrate/bokio']

if (!window.location.hash && integrateRedirects.includes(window.location.pathname)) {
	const search = window.location.search || ''
	window.location.replace(`${window.location.origin}/${search}#!${window.location.pathname}`)
}
ReactDOM.render(
	<React.StrictMode>
		<SentryErrorBoundary>
			<HashRouter hashType='hashbang'>
				<App />
			</HashRouter>
		</SentryErrorBoundary>
	</React.StrictMode>,
	document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
